import { TimeIntervals } from "./tradingView/timeInterval";

export const TradingView = () => {
  return (
    <div className="orderly-h-[300px]">
      <TimeIntervals />
      TradingView
    </div>
  );
};
